import axios from "axios";
//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers

//Status Bar
import {
	newStatus,
	setStatusTimeout
} from '../FlexiGrid/features/statusbar/statusbarSlice';

/* ##########################  Configuration  ########################## */

//DB
var dbendpoint = process.env.REACT_APP_DB_API4;


//Load Item
function LoadItem(localstate, UpdateState, configuration, dispatch) {
	//Axios Post Options
	const postoptions = {
		withCredentials: true,
		withXSRFToken: true,
		crossDomain: true,
		mode: "no-cors",
		timeout: configuration.shortposttimeout,
	};


	//Try: Clear any error messages on load of any item:
	dispatch(setStatusTimeout(0));
	const postdata = {
		dbkey: configuration['dbkey'],
		dbkeyvalue : configuration['dbkeyvalue'],
		dbmodel : configuration['dbmodel'],
		nestedrelationships: configuration['nestedrelationships'],
		datetimes: configuration['datetimes'],
	};
	axios.post(dbendpoint + configuration.fetchapiendpoint, postdata, postoptions).then(res => {
		//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
		if (res.status === 200) {
			//If ValidateUser() fails to verify user, it sends back 'login' error. 
			if (res.data.Status === "login") {
				//Not logged in. Reload page causes redirect to /login
				window.location.reload(false);
			}
			//All new API calls should return a status.
			if (res.data.Status === "Success") {
				localstate.itemdata = res.data.item;

				//Datetime Formatting
				for (var i=0; i<configuration.datetimes.length; i++){
					console.log("Formatting: "+configuration.datetimes[i]+" value "+localstate.itemdata[configuration.datetimes[i]]);
					console.log ("Into: "+dayjs(localstate.itemdata[configuration.datetimes[i]]));
					localstate.itemdata[configuration.datetimes[i]] = dayjs(localstate.itemdata[configuration.datetimes[i]]);
				}

				//Floats
				for (var i=0; i<configuration.floats.length; i++){
					localstate.itemdata[configuration.floats[i]] = parseFloat(localstate.itemdata[configuration.floats[i]]).toFixed(2);
				}
				
				localstate.dbreload = false;
				//Set Defaults on first load:
				console.log("DATA LOADED");
				if (!localstate.itemloaded){
					localstate.itemdatadefaults = localstate.itemdata;
					localstate.itemloaded = true; //Now allow render
				}
				//Show a warning to the user when they're viewing a deleted item
				if (localstate.itemdata.SoftDelete===1){
					dispatch(newStatus({
						type: "warning",
						msg: 'This is a deleted item.',
						show: true,
						settimeout: true, //This option allows for a timeout after the final item is pass/failed
						timeout: 5, //Initiated on final item 
						itemtype: 'items', //Labels your save types such as items, products, skus, parts
						finished: 0,
						percent: "0%",
						pass: 0,
						fail: 0,
						faillist: [], //Can take simple values,
						faillinks: [], //Can take links to things like items or products.
						timeoutid: false,
						errors: [] //Can take strings
					}));
					dispatch(setStatusTimeout(30000));
				} else {
					dispatch(newStatus({
						type: "dataloaded",
						msg: 'Data loaded',
						show: true,
						settimeout: true, //This option allows for a timeout after the final item is pass/failed
						timeout: 5, //Initiated on final item 
						itemtype: 'items', //Labels your save types such as items, products, skus, parts
						finished: 0,
						percent: "0%",
						pass: 0,
						fail: 0,
						faillist: [], //Can take simple values,
						faillinks: [], //Can take links to things like items or products.
						timeoutid: false,
						errors: [] //Can take strings
					}));
					dispatch(setStatusTimeout(500));
				}
				UpdateState(localstate);

				
			}
			if (res.data.Status === "Failure") {
				//Failure error
				localstate.dbreload = false;
				UpdateState(localstate);
				// dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
				// dispatch(setErrorTimeout(10));
			}
		} else {
			//Non-200 message from server.
			// dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
			// dispatch(setErrorTimeout(15));
		}
	});
}

export default LoadItem;